import {MarketLanguage} from './market-language';

export class DotcomMarket {
  name: string;
  flag: string;
  languages: MarketLanguage[];
}
